<template>
  <v-container ma-0 pa-0 fluid>
    <v-toolbar class="primary d-flex align-center">
      <v-toolbar-title class="white--text">
        Other Charges (Internal)
      </v-toolbar-title>
      <v-btn class="ml-4 secondary" @click="addRow()">Add row</v-btn>
      <v-checkbox
        v-if="allFlags.SOG4537"
        v-model="isReporting"
        class="ml-5"
        name="isReporting"
        label="Use for reporting purpose only"
        color="white"
        dark
        hide-details
      ></v-checkbox>
    </v-toolbar>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-card>
        <v-card-text>
          <table
            class="
              table table-striped table-bordered
              mobile-table
              custom-table
              my-0
            "
          >
            <thead>
              <tr>
                <th></th>
                <th>Service</th>
                <th>CSN (recontract)</th>
                <th>Item</th>
                <th>Quantity</th>
                <th>Item Amount</th>
                <th>Retail Charge (EX GST)</th>
                <th>Discount (%)</th>
                <th>Total Cost (EX GST)</th>
                <th v-if="allFlags.SOG3790">Payment</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(charges, index) in details" :key="index">
                <td style="padding: 5px !important" width="5%">
                  <v-icon v-show="charges.id > 0" color="green" title="Saved">
                    check_circle
                  </v-icon>
                  <v-icon title="Delete" @click="removeRow(charges, index)">
                    delete
                  </v-icon>
                </td>
                <td style="padding: 5px !important" width="15%">
                  <vonex-select
                    v-model="charges.service"
                    :items="services"
                    :rule="`required`"
                    item-text="category"
                    item-value="installationCategoryID"
                    dense
                    class="form-control custom-td"
                    hide-details
                    @change="onSelect(charges.service, index)"
                  ></vonex-select>
                </td>
                <td>
                  <vonex-text
                    v-model="charges.csn"
                    class="text-right"
                    hide-details
                    solo
                  ></vonex-text>
                </td>

                <td
                  style="padding: 5px !important"
                  :width="allFlags.SOG3790 ? '20%' : '25%'"
                >
                  <vonex-select
                    v-if="!charges.isFreeType"
                    v-model="charges.itemDetails"
                    :items="filterItems(charges.service)"
                    :rule="`required`"
                    item-text="itemDetails"
                    item-value="serviceID"
                    :disabled="charges.service == ''"
                    dense
                    class="form-control custom-td"
                    hide-details
                    @change="onSelectPopulate(charges.itemDetails, index)"
                  ></vonex-select>
                  <vonex-text
                    v-else
                    v-model="charges.itemDetails"
                    class="text-right"
                    hide-details
                    solo
                    :rule="`required`"
                    :options="fieldConditions"
                  ></vonex-text>
                  <v-checkbox
                    v-model="charges.isFreeType"
                    label="Custom Item Description"
                    :disabled="charges.service == ''"
                    hide-details
                    solo
                    :rule="`required`"
                    @change="onSelectManual(charges.itemDetails, index)"
                  ></v-checkbox>
                </td>
                <td
                  style="padding: 5px !important"
                  :width="allFlags.SOG3790 ? '7%' : '10%'"
                >
                  <vonex-text
                    v-model.number="charges.quantity"
                    type="number"
                    class="text-right"
                    min="0"
                    :name="'quantity' + index"
                    hide-details
                    solo
                    :options="fieldConditions"
                    @input="calculateRowCost(charges, index)"
                  ></vonex-text>
                </td>
                <td
                  style="padding: 5px !important"
                  width="10%"
                  class="currency"
                >
                  <vonex-text
                    v-model="charges.amount"
                    type="number"
                    prefix="$"
                    :name="'amount' + index"
                    hide-details
                    solo
                    @change="formatDecimal(charges, index, 'amount')"
                    @input="calculateRowCost(charges, index)"
                  ></vonex-text>
                </td>
                <td
                  style="padding: 5px !important"
                  width="10%"
                  class="currency"
                >
                  <div class="cost">
                    {{ charges.cost | currency }}
                  </div>
                </td>
                <td
                  style="padding: 7px !important"
                  :width="allFlags.SOG3790 ? '7%' : '10%'"
                >
                  <vonex-text
                    v-model.number="charges.discount"
                    type="number"
                    max="0"
                    :name="'discount' + index"
                    hide-details
                    solo
                    :options="fieldConditions"
                    :disabled="charges.cost == 0"
                    @input="calculateRowCost(charges, index)"
                  ></vonex-text>
                </td>
                <td
                  style="padding: 5px !important"
                  :width="allFlags.SOG3790 ? '7%' : '10%'"
                  class="currency"
                >
                  <vonex-text
                    v-model.number="charges.totalCost"
                    type="number"
                    min="0"
                    prefix="$"
                    :name="'amount' + index"
                    hide-details
                    solo
                    :disabled="charges.cost == 0"
                    :options="fieldConditions"
                    @change="formatDecimal(charges, index, 'totalCost')"
                    @input="getRowDiscount(charges, index)"
                  ></vonex-text>
                </td>
                <td v-if="allFlags.SOG3790" style="padding: 5px !important">
                  <v-radio-group v-model="charges.paymentType" row hide-details>
                    <v-radio label="Once-off" value="once" :disabled="allFlags.SOG9302 && isFibre4GBackUp(charges.itemDetails)"></v-radio>
                    <v-radio label="Recurring" value="recurring"></v-radio>
                  </v-radio-group>
                  <div v-if="charges.paymentType == 'recurring'">
                    <vonex-select
                      v-model="charges.recurringChargeFrequency"
                      :name="`recurringChargeFrequency-${index}`"
                      label="Recurring"
                      :items="['Monthly']"
                      :rule="`required`"
                      dense
                      class="form-control custom-td"
                      hide-details
                      :disabled="allFlags.SOG9302 && isFibre4GBackUp(charges.itemDetails)"
                    ></vonex-select>
                    <vonex-select
                      v-model="charges.contractLength"
                      :name="`contractLength-${index}`"
                      label="Contract Length"
                      :items="contractLength"
                      :rule="`required`"
                      dense
                      hide-details
                      :disabled="allFlags.SOG9302 && isFibre4GBackUp(charges.itemDetails)"
                    ></vonex-select>
                  </div>
                </td>
              </tr>
              <tr style="background: #ddd">
                <td align="center" :colspan="allFlags.SOG3790 ? '7' : '6'"></td>
                <td
                  style="padding: 5px 7px !important"
                  align="center"
                  colspan="1"
                >
                  Subtotal - Ex GST
                </td>
                <td
                  style="padding: 5px 7px !important"
                  colspan="1"
                  class="currency"
                >
                  {{ sumLineTotals | currency }}
                </td>
              </tr>
              <tr style="background: #ddd">
                <td align="center" :colspan="allFlags.SOG3790 ? '7' : '6'"></td>
                <td
                  style="padding: 5px 7px !important"
                  align="center"
                  colspan="1"
                >
                  GST
                </td>
                <td
                  style="padding: 5px 7px !important"
                  colspan="1"
                  class="currency"
                >
                  {{ gst | currency }}
                </td>
              </tr>
              <tr style="background: #ddd">
                <td align="center" :colspan="allFlags.SOG3790 ? '7' : '6'"></td>
                <td
                  style="padding: 5px 7px !important"
                  align="center"
                  class="font-weight-bold"
                  colspan="1"
                >
                  Total
                </td>
                <td
                  style="padding: 5px 7px !important"
                  class="currency font-weight-bold"
                  colspan="1"
                >
                  {{ (sumLineTotals + gst) | currency }}
                </td>
              </tr>
            </tbody>
          </table>
          <message-alert
            :component="$store.getters[`orders/installationCharges/message`]"
          ></message-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="primary"
            :disabled="invalid || novalue"
            @click="saveCharges"
          >
            Save Other Charges
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
    <v-dialog v-if="dialog" v-model="dialog" max-width="700" persistent>
      <recurring-charge-details
        :charge="selectedCharge"
        :isViewing="isViewing"
        :recurringChargeDetails="recurringChargeDetails"
        @recurringChargeDetails="updateCharge"
        @cancel="dialog = false"
      ></recurring-charge-details>
    </v-dialog>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapOrderState, mapMutations: mapOrderMutations } =
  createNamespacedHelpers(`orders`);
const {
  mapState: mapInstallationChargesState,
  mapGetters: mapInstallationChargesGetters,
  mapMutations: mapInstallationChargesMutations,
  mapActions: mapInstallationChargesActions,
} = createNamespacedHelpers(`orders/installationCharges`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
import { httpError } from '../models/httpError';
import InstallationCharges from '../models/InstallationCharges';
import RecurringChargeDetails from '@/components/dialogs/RecurringChargeDetails';

export default {
  name: 'InstallationCharges',
  components: { RecurringChargeDetails },
  data() {
    return {
      details: [],
      dialog: false,
      selectedCharge: {},
      selectedIndex: null,
      isViewing: false,
      recurringChargeDetails: {},
      contractLength: [
        {
          text: 'No Contract',
          value: 1,
        },
        {
          text: '12 months',
          value: 12,
        },
        {
          text: '24 months',
          value: 24,
        },
        {
          text: '36 months',
          value: 36,
        },
        {
          text: '48 months',
          value: 48,
        },
        {
          text: '60 months',
          value: 60,
        },
      ],
      isReporting: false,
    };
  },
  computed: {
    ...mapOrderState(['rows', 'customer']),
    ...mapInstallationChargesState(['services', 'servicesItems']),
    ...mapInstallationChargesGetters(['installationCharges']),
    ...mapFeatureFlagGetters(['allFlags']),
    gst() {
      let vm = this;
      return vm.sumLineTotals / 10;
    },
    sumLineTotals() {
      let vm = this;
      let total = 0;
      if (vm.details) {
        vm.details.forEach((x) => {
          total = total + +x.totalCost;
        });
      }
      return total;
    },
    novalue() {
      let vm = this;
      let data = vm.details.map((x) => x.itemDetails);
      if (
        data.includes(NaN) ||
        data.includes(0) ||
        data.includes(undefined) ||
        data.includes('')
      )
        return true;
      else return false;
    },
  },
  mounted() {
    let vm = this;
    vm.getCharges();
    vm.isReporting = vm.rows[0].isReporting;
  },
  methods: {
    ...mapInstallationChargesMutations(['DELETE_INSTALLATION_CHARGES']),
    ...mapInstallationChargesActions([
      'getInstallationCharges',
      'upsertInstallationCharge',
      'deleteInstallationCharges',
      'setMessage',
      'getRecurringChargeDetails',
    ]),
    ...mapOrderMutations(['setIsReporting']),
    async getCharges() {
      let vm = this;
      let data = await vm.getInstallationCharges(vm.rows[0].orderID);
      vm.$nextTick(() => {
        if (data.length > 0) {
          vm.details = data.map((row) => {
            let tempRow = new InstallationCharges(row);
            tempRow.amount = tempRow.amount.toFixed(2);
            tempRow.totalCost = tempRow.totalCost.toFixed(2);
            tempRow.paymentType = !tempRow.recurringChargeFrequency
              ? 'once'
              : 'recurring';
            return tempRow;
          });
          vm.setMessage({
            message: 'Retrieve OK',
            httpStatus: 200,
          });
        } else {
          vm.details = [];
          vm.addRow();
        }
      });
    },
    isFibre4GBackUp(itemDetails) {
      const selected = this.servicesItems.find((x) => x.serviceID === itemDetails);
      return !!(selected && selected.itemDetails === 'Add to existing Fibre Service');
    },
    addRow() {
      let vm = this;
      let charge = new InstallationCharges();
      charge.orderId = vm.rows[0].orderID;
      vm.details.push(charge);
    },
    removeRow(charge, index) {
      let vm = this;
      let toDelete = {
        charge: charge,
        index: index,
      };
      this.$dialog
        .confirm('You are about to delete a charge, are you sure?')
        .then(() => {
          if (charge.id == 0) {
            vm.DELETE_INSTALLATION_CHARGES(index);
            vm.getCharges();
          } else {
            vm.deleteInstallationCharges(toDelete).then((res) => {
              if (res) vm.getCharges();
            });
          }
        });
    },
    filterItems(categoryId) {
      let vm = this;
      if (vm.servicesItems && vm.servicesItems.length > 0)
        return vm.servicesItems.filter(
          (x) => x.installationCategoryID == categoryId
        );
      else return null;
    },
    onSelect(value, index) {
      let vm = this;
      let selected = vm.servicesItems.filter((x) => x.serviceID === value);
      if (selected) {
        vm.details[index].itemDetails = 0;
        vm.details[index].amount = 0;
        vm.details[index].cost = 0;
        vm.details[index].isFreeType = false;
      }
    },
    onSelectManual(value, index) {
      let vm = this;
      let selected = vm.servicesItems.filter((x) => x.serviceID === value);
      if (selected) {
        vm.details[index].itemDetails = undefined;
        vm.details[index].amount = 0;
        vm.details[index].cost = 0;
      }
    },
    onSelectPopulate(value, index) {
      let vm = this;
      let selected = vm.servicesItems.filter((x) => x.serviceID === value)[0];
      if (selected) {
        vm.details[index].amount = selected.amount;
        vm.details[index].cost = selected.retailCharge;
        vm.details[index].quantity = 1;
        vm.details[index].discount = 0;
        vm.calculateRowCost(vm.details[index], index);

        if (vm.isFibre4GBackUp(selected.serviceID)) {
          vm.details[index].paymentType = 'recurring';
          vm.details[index].recurringChargeFrequency = 'Monthly';
          vm.details[index].contractLength = 1;
        }
      }
    },
    formatDecimal(charges, index, field) {
      charges[field] = parseFloat(charges[field]).toFixed(2);
      return charges;
    },
    calculateRowCost(charges, index) {
      let vm = this;
      const { amount, quantity, discount } = charges;
      if (discount < 0) {
        charges.discount = 0;
        return;
      }
      if (amount < 0) {
        charges.amount = charges.cost / charges.quantity;
        return;
      }
      let cost = (amount * quantity).toFixed(2);
      charges.cost = cost;
      vm.details[index] = vm.calculateRowTotal(charges, index);
      charges = vm.formatDecimal(charges, index, 'totalCost');
      return cost;
    },
    calculateRowDiscount(charges, index) {
      let vm = this;
      charges.totalCost -= (charges.cost * (charges.discount / 100)).toFixed(2);
      charges = vm.formatDecimal(charges, index, 'totalCost');
      return charges;
    },
    calculateRowTotal(charges, index) {
      let vm = this;
      charges.totalCost = charges.cost;
      if (charges.discount > 0) {
        charges = vm.calculateRowDiscount(charges, index);
      }
      return charges;
    },
    getRowDiscount(charges, index) {
      let vm = this;
      const { totalCost, cost } = charges;
      if (totalCost >= cost || totalCost < 0) {
        charges.totalCost = cost;
        charges.discount = 0;
        return;
      }
      let discount = (cost - totalCost) / cost;
      charges.discount = (discount * 100).toFixed(2);
      vm.details[index] = charges;
    },
    saveCharges() {
      let vm = this;
      vm.setMessage(new httpError());
      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (result) {
            vm.details.forEach((x) => {
              x.amount = parseFloat(x.amount);
              x.cost = parseFloat(x.cost);
              x.discount = parseFloat(x.discount);
              x.totalCost = parseFloat(x.totalCost);
              x.recurringChargeFrequency =
                x.paymentType == 'once' ? '' : x.recurringChargeFrequency;
            });
            vm.upsertInstallationCharge({
              orderID: vm.rows[0].orderID,
              charges: vm.details,
              isReporting: vm.isReporting,
            }).then((res) => {
              if (res) {
                vm.getCharges();
                vm.setIsReporting(vm.isReporting);
              }
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    async showDialog(charge, index) {
      let vm = this;
      vm.selectedCharge = charge;
      vm.selectedIndex = index;
      vm.isViewing = charge.recurringChargeID > 0;
      if (vm.isViewing)
        vm.recurringChargeDetails = await vm.getRecurringChargeDetails(
          charge.recurringChargeID
        );
      else {
        vm.recurringChargeDetails = {
          customerNo:
            vm.customer.customer.ubAccountNo > 0
              ? vm.customer.customer.ubAccountNo
              : '',
          serviceNo: '',
          code: '',
          startDate: new Date().toISOString().substr(0, 10),
        };
      }
      vm.dialog = true;
    },
    updateCharge(data) {
      let vm = this;
      vm.details[vm.selectedIndex].recurringChargeID = parseInt(data.id);
      vm.selectedCharge = {};
      vm.selectedIndex = null;
      vm.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-table {
  ::v-deep .v-text-field .v-input__control .v-input__slot {
    min-height: auto;
    padding: 3px 10px;
  }

  ::v-deep .v-text-field .v-input__control {
    min-height: 40px;
  }
}
.currency {
  text-align: right;
}
.no-grid td {
  border: 0 !important;
}
td .cost {
  text-align: left;
  font-size: 15px;
  padding: 8px;
  line-height: 1.42857143;
  box-shadow: 0 2px 3px #9d9a9a;
  background: #fff;
}
td.only-grid {
  border: 1px solid #ddd !important;
  padding: 7px !important;
}
</style>
